// extracted by mini-css-extract-plugin
module.exports = {"previewTabs":"CustomTypePreviewRenderer_previewTabs__2TZ6H"};